import React from 'react';
import ImageThumbnail from './ImageThumbnail';

/**
 * Grid of image thumbnails for the selected review.
 */
function ImageGallery({ images, onOpenModal }) {
  if (!images.length) {
    return (
      <div className="p-8 bg-yellow-50 border border-yellow-200 rounded-lg text-center mb-6">
        <p className="text-gray-700 font-medium">Brak zdjęć dla tej opinii</p>
        <p className="text-sm text-gray-500 mt-2">
          Ta opinia nie ma przypisanych zdjęć w R2
        </p>
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6"
      role="list"
      aria-label="Galeria zdjęć z opinii"
    >
      {images.map((image, index) => (
        <div key={index} role="listitem">
          <ImageThumbnail
            image={image}
            index={index}
            onOpenModal={onOpenModal}
          />
        </div>
      ))}
    </div>
  );
}

export default ImageGallery;
